import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check, Globe } from "lucide-react";
import { Bluelagoon } from "@bluelagoon";

export default function TriggerWebhookSection({ trigger }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const baseUrl = Bluelagoon.apiUrl || "https://api.agentui.ai";
    const webhookUrl = `${baseUrl}/webhook/${trigger.publicKey}`;

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(webhookUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }, [webhookUrl]);

    return (
        <div className="p-4 space-y-4">
            <div>
                <label className="text-xs font-medium text-gray-700 block mb-1">{t("chatInput.webhookUrl")}</label>
                <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg p-2">
                    <Globe size={14} className="text-gray-400 flex-shrink-0" />
                    <code className="text-xs text-gray-700 break-all flex-1">{webhookUrl}</code>
                    <button onClick={handleCopy} className="p-1 hover:bg-gray-200 rounded flex-shrink-0">
                        {copied ? <Check size={14} className="text-green-500" /> : <Copy size={14} className="text-gray-400" />}
                    </button>
                </div>
            </div>
            <div>
                <label className="text-xs font-medium text-gray-700 block mb-1">{t("chatInput.method")}</label>
                <p className="text-sm text-gray-600">POST</p>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-700">
                    {t("chatInput.webhookTriggerHelp")}
                </p>
            </div>
        </div>
    );
}
